"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик на карточку с номером телефона, пока он еще скрыт (При повторном нажатии будет отправлено событие applicant_call_intent) */
const contactsShowPhoneButtonClick = ({ vacancyId, numberType, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("show_phone_number", { vacancyId, numberType, ...analyticsParams });
exports.default = contactsShowPhoneButtonClick;
